<!--==============================
=            COMBOBOX            =
===============================-->

<template>
  <v-container>
    <v-row no-gutters>
      <base-header>
        <div slot="page-header">Combobox</div>
      </base-header>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">With Combobox,</div>
          <div slot="card-body">
            <div>
              <v-container fluid>
                <v-row>
                  <v-col cols="12">
                    <v-combobox
                      v-model="select"
                      :items="items"
                      label="Select a favorite activity or create a new one"
                    ></v-combobox>
                  </v-col>
                  <v-col cols="12">
                    <v-combobox v-model="select" :items="items" chips label="I use chips"></v-combobox>
                  </v-col>
                  <v-col cols="12">
                    <v-combobox v-model="select" :items="items" chips label="I use a scoped slot">
                      <template v-slot:selection="data">
                        <v-chip
                          :key="JSON.stringify(data.item)"
                          v-bind="data.attrs"
                          :input-value="data.selected"
                          :disabled="data.disabled"
                          @click.stop="data.parent.selectedIndex = data.index"
                          @click:close="data.parent.selectItem(data.item)"
                        >
                          <v-avatar
                            class="accent white--text"
                            left
                          >{{ data.item.slice(0, 1).toUpperCase() }}</v-avatar>
                          {{ data.item }}
                        </v-chip>
                      </template>
                    </v-combobox>
                  </v-col>
                  <v-col cols="12">
                    <v-combobox v-model="select" chips label="I'm readonly" readonly></v-combobox>
                  </v-col>
                </v-row>
              </v-container>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Playground</div>
          <div slot="card-body">
            <div>
              <div>
                <v-row justify="space-around">
                  <v-switch v-model="chips" label="Chips"></v-switch>
                  <v-switch v-model="multiple" label="Multiple"></v-switch>
                  <v-switch v-model="hideSelected" label="Hide selected"></v-switch>
                  <v-switch v-model="noData" label="No data slot"></v-switch>
                  <v-switch v-model="clearable" label="Clearable"></v-switch>
                </v-row>

                <v-combobox
                  v-model="model"
                  :items="items1"
                  :search-input.sync="search"
                  :hide-selected="hideSelected"
                  label="Add some tags"
                  :multiple="multiple"
                  persistent-hint
                  :small-chips="chips"
                  :clearable="clearable"
                >
                  <template v-if="noData" v-slot:no-data>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>
                          No results matching "
                          <strong>{{ search }}</strong>". Press
                          <kbd>enter</kbd> to create a new one
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-combobox>
              </div>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Multiple combobox</div>
          <div slot="card-body">
            <div>
              <v-container fluid>
                <v-row>
                  <v-col cols="12">
                    <v-combobox
                      v-model="select"
                      :items="items2"
                      label="Select a favorite activity or create a new one"
                      multiple
                    ></v-combobox>
                  </v-col>
                  <v-col cols="12">
                    <v-combobox v-model="select" :items="items2" label="I use chips" multiple chips></v-combobox>
                  </v-col>
                  <v-col cols="12">
                    <v-combobox
                      v-model="select"
                      :items="items2"
                      label="I use a scoped slot"
                      multiple
                      chips
                    >
                      <template v-slot:selection="data">
                        <v-chip
                          :key="JSON.stringify(data.item)"
                          v-bind="data.attrs"
                          :input-value="data.selected"
                          :disabled="data.disabled"
                          @click:close="data.parent.selectItem(data.item)"
                        >
                          <v-avatar
                            class="accent white--text"
                            left
                            v-text="data.item.slice(0, 1).toUpperCase()"
                          ></v-avatar>
                          {{ data.item }}
                        </v-chip>
                      </template>
                    </v-combobox>
                  </v-col>
                  <v-col cols="12">
                    <v-combobox v-model="select" label="I'm readonly" chips multiple readonly></v-combobox>
                  </v-col>
                </v-row>
              </v-container>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Dense</div>
          <div slot="card-body">
            <div>
              <v-container fluid>
                <v-row>
                  <v-col cols="12">
                    <v-combobox
                      v-model="select"
                      :items="items3"
                      label="Combobox"
                      multiple
                      outlined
                      dense
                    ></v-combobox>
                  </v-col>
                </v-row>
              </v-container>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">No data with chips</div>
          <div slot="card-body">
            <div>
              <v-container fluid>
                <v-combobox
                  v-model="model"
                  :items="items4"
                  :search-input.sync="search"
                  hide-selected
                  hint="Maximum of 5 tags"
                  label="Add some tags"
                  multiple
                  persistent-hint
                  small-chips
                >
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>
                          No results matching "
                          <strong>{{ search }}</strong>". Press
                          <kbd>enter</kbd> to create a new one
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-combobox>
              </v-container>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";
export default {
  components: {
    BaseCard,
    BaseHeader
  },
  data() {
    return {
      select: "Programming",
      items: ["Programming", "Design", "Vue", "Vuetify"],
      items4: ["Gaming", "Programming", "Vue", "Vuetify"],
      model: ["Vuetify"],
      search: null,
      items1: ["Gaming", "Programming", "Vue", "Vuetify"],
      model: ["Vuetify"],
      search: null,
      chips: true,
      multiple: true,
      hideSelected: true,
      noData: true,
      clearable: false,
      select: ["Vuetify", "Programming"],
      items2: ["Programming", "Design", "Vue", "Vuetify"],
      select: ["Vuetify", "Programming"],
      items3: ["Programming", "Design", "Vue", "Vuetify"]
    };
  },
  watch: {
    model(val) {
      if (val.length > 5) {
        this.$nextTick(() => this.model.pop());
      }
    }
  }
};
</script>

<!--====  End of COMBOBOX  ====-->
